import React, { useEffect, useMemo, useState } from "react";

import getMetrics from "src/organization/pages/project/environment/metrics/api/getMetrics";
import { getMetricQuery } from "src/organization/pages/project/environment/metrics/http/helper";
import { usePollgroupContext } from "src/organization/pages/project/environment/metrics/utils/polling/usePollgroup";

import { GRID_QUERY } from "../settings";
import { ResourceType } from "../types";

import { reAttachPersistentDisk } from "./grid.utils";
import TotalUsage, { TotalUsageProps } from "./TotalUsage";
import UsageViewSkeleton from "./UsageViewSkeleton";
import usePoll from "./usePoll";

type UsageViewProps = {
  isOnviewport?: boolean;
} & Omit<TotalUsageProps, "data">;

const pollerId = "total-resources-poller";

const fetchMetrics = (href, timeframe, collection) => {
  const query = getMetricQuery({
    timeframe,
    collection,
    fields: GRID_QUERY
  });
  return getMetrics<ResourceType>(href, query);
};

const UsageView = (props: UsageViewProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const { timeframe, activities, setTimeFrame, setLastUpdated, isOnviewport } =
    props;

  const { pollgroup } = usePollgroupContext();

  const { data, poller, metricsLink } = usePoll({
    onChange: () => setLastUpdated?.(new Date()),
    onLoadingChange: setIsLoading
  });

  useEffect(() => {
    if (metricsLink) {
      const { href, collection } = metricsLink;
      poller.setAsyncFn(t => fetchMetrics(href, t, collection));
      pollgroup.registerPollerIfNotExists(pollerId, poller);
      pollgroup.setPollerPaused(pollerId, !isOnviewport);
    }
  }, [isOnviewport, metricsLink, poller, pollgroup]);

  const serviceData = useMemo(() => reAttachPersistentDisk(data), [data]);

  return isLoading ? (
    <UsageViewSkeleton />
  ) : (
    <TotalUsage
      timeframe={timeframe}
      activities={activities}
      setTimeFrame={setTimeFrame}
      data={serviceData.services}
    />
  );
};

export default UsageView;
